import { DateTime, getToday } from './date-helpers';
const getSessions = (movie, timeZone) => (movie.sessions || []).reduce((acc, session) => {
  const dt = DateTime.fromISO(session.startTime, {
    timeZone
  });
  const dayDiff = DateTime.moment.duration(dt.startOf('day').diff(getToday(timeZone))).days();
  if (!acc[dayDiff]) {
    acc[dayDiff] = dt.format('YYYY-MM-DD');
  }
  return acc;
}, []).filter(sessionsOfDay => sessionsOfDay !== null);
const getMoviesWithSessions = (movies, timeZone) => (movies || []).map(m => {
  var _m$genres, _m$classification;
  return {
    id: m.id,
    title: m.title,
    image: m.imageUrl || '',
    genre: (m === null || m === void 0 || (_m$genres = m.genres) === null || _m$genres === void 0 ? void 0 : _m$genres[0]) || '',
    classification: (m === null || m === void 0 || (_m$classification = m.classification) === null || _m$classification === void 0 ? void 0 : _m$classification.rating) || '',
    sessions: getSessions(m, timeZone)
  };
});
export default getMoviesWithSessions;